import teamSetupPickerStore from "../store/store";
import { mutatorAction } from "satcheljs";
import { TeamSetupPickerStepState } from "../store/schema/TeamSetupPickerStore";
import { trace } from "owa-trace";

/**
 * Updates the current step in the team setup flow to the next state.
 */

export default mutatorAction('GOTO_NEXT_SETUP_STEP', function gotoNextSetupStep() {
    if ((teamSetupPickerStore.currentSetupStepIndex >= 0) &&
        teamSetupPickerStore.setupSequence &&
        (teamSetupPickerStore.currentSetupStepIndex < teamSetupPickerStore.setupSequence.length - 1)) {
            // Clear any error message from previous step
            teamSetupPickerStore.errorMessage = null;
            teamSetupPickerStore.currentSetupStepIndex++;
    } else {
        trace.warn("Team setup: error with gotoNextSetupStep occurred");
    }
});
